/* PF47 home interactions: mobile drawer, add to bag, reviews arrow, newsletter state */
(() => {
  const drawer = document.querySelector('[data-pf-drawer]');
  document.querySelectorAll('[data-pf-drawer-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const open = !drawer.classList.contains('is-open');
      drawer.classList.toggle('is-open', open);
      document.querySelector('.pf-burger')?.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
  });
  const closeDrawer = () => {
    drawer?.classList.remove('is-open');
    document.querySelector('.pf-burger')?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };
  drawer?.querySelectorAll('a').forEach((a) => a.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer(); });

  // Expose the sticky header height (Impact reads these for sticky elements and anchor scrolling).
  const stickyHeader = document.querySelector('.pf-header-section');
  if (stickyHeader && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      const h = `${Math.round(stickyHeader.getBoundingClientRect().height)}px`;
      document.documentElement.style.setProperty('--header-height', h);
      document.documentElement.style.setProperty('--sticky-area-height', h);
    }).observe(stickyHeader);
  }

  const setCount = (n) => document.querySelectorAll('[data-pf-cart-count]').forEach((el) => {
    el.textContent = n;
    el.dataset.count = n;
  });
  // Keep the PF47 header count in sync when Impact sections or cart apps change the cart.
  const refreshCount = async () => {
    try { setCount((await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json()).item_count); } catch (err) { /* offline */ }
  };
  ['cart:change', 'cart:refresh', 'cart:updated'].forEach((name) => document.addEventListener(name, refreshCount));
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-pf-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
    const label = btn.innerHTML;
    btn.disabled = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      setCount(cart.item_count);
      btn.textContent = btn.dataset.added || 'Aggiunto ✓';
      setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 1800);
    } catch (err) {
      btn.disabled = false;
      form.submit();
    }
  });

  document.querySelectorAll('[data-pf-next]').forEach((btn) => {
    const track = document.getElementById(btn.dataset.pfNext);
    btn.addEventListener('click', () => {
      const card = track.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
    });
  });
  document.querySelectorAll('[data-pf-prev]').forEach((btn) => {
    const track = document.getElementById(btn.dataset.pfPrev);
    btn.addEventListener('click', () => {
      const card = track.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      const atStart = track.scrollLeft <= 4;
      track.scrollTo({ left: atStart ? track.scrollWidth : track.scrollLeft - step, behavior: 'smooth' });
    });
  });

  // ---------- product page ----------
  const formatMoney = (cents, format) => {
    const fmt = format || '€{{amount_with_comma_separator}}';
    const n = (cents / 100).toFixed(2);
    const [int, dec] = n.split('.');
    const group = (sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      if (key === 'amount_with_comma_separator') return `${group('.')},${dec}`;
      if (key === 'amount_no_decimals_with_comma_separator') return group('.');
      if (key === 'amount_no_decimals') return group(',');
      return `${group(',')}.${dec}`;
    });
  };

  document.querySelectorAll('[data-pf-pdp]').forEach((pdp) => {
    const unit = Number(pdp.dataset.unit);
    const fmt = pdp.dataset.moneyFormat;
    const qtyInput = pdp.querySelector('[data-pf-qty]');
    const set = (sel, text) => pdp.querySelectorAll(sel).forEach((el) => { el.textContent = text; });
    pdp.querySelectorAll('.pf-tier input').forEach((input) => {
      input.addEventListener('change', () => {
        pdp.querySelectorAll('.pf-tier').forEach((t) => t.classList.toggle('is-selected', t.contains(input)));
        const qty = Number(input.value);
        const pct = Number(input.dataset.discount || 0);
        const full = input.dataset.full ? Number(input.dataset.full) : unit * qty;
        const total = input.dataset.total ? Number(input.dataset.total) : Math.round(full * (100 - pct) / 100);
        qtyInput.value = qty;
        const idInput = qtyInput.form && qtyInput.form.querySelector('[name="id"]');
        if (idInput && input.dataset.variant) idInput.value = input.dataset.variant;
        set('[data-pf-total]', formatMoney(total, fmt));
        set('[data-pf-btn-total]', formatMoney(total, fmt));
        set('[data-pf-full]', formatMoney(full, fmt));
        set('[data-pf-third]', formatMoney(Math.round(total / 3), fmt));
        set('[data-pf-save-pct]', pct);
        pdp.querySelectorAll('[data-pf-full]').forEach((el) => { el.hidden = total >= full; });
        pdp.querySelectorAll('[data-pf-save]').forEach((el) => { el.hidden = pct === 0; });
      });
    });

    // Description from Shopify: label-only lines ("IDEALE PER:", "MODO D'USO:"...) are hidden, only the text stays.
    // FAQ questions ("Lascia la pelle unta?") stay visible; an all-caps label like "A COSA SERVE?" is still hidden.
    pdp.querySelectorAll('[data-pf-desc]').forEach((desc) => {
      desc.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div').forEach((el) => {
        const text = el.textContent.trim();
        if (!text || el.querySelector('ul, ol, p, div')) return;
        if (/\?$/.test(text) && text !== text.toUpperCase()) return;
        const plain = el.cloneNode(true);
        plain.querySelectorAll('strong, b, em, i').forEach((m) => m.remove());
        const label = /^H\d$/.test(el.tagName) || (!plain.textContent.trim() && (/:$/.test(text) || text === text.toUpperCase()));
        if (label) el.hidden = true;
      });
    });

    // Long descriptions: how to use, kit contents and ingredients get their own panel instead of one block of text.
    pdp.querySelectorAll('[data-pf-desc]').forEach((desc) => {
      const item = desc.closest('details');
      if (!item) return;
      const groups = [
        { title: 'Come si usa', re: /^(MODO D.USO|COME SI USA)/ },
        { title: 'Cosa contiene il kit', re: /^(COSA CONTIENE|CONTIENE IL KIT)/ },
        { title: 'Ingredienti', re: /^(INGREDIENTI|INCI)/ },
      ];
      const moved = new Map();
      let current = null;
      [...desc.children].forEach((el) => {
        const strong = el.querySelector('strong, b');
        const text = el.textContent.trim();
        const lead = el.hidden ? text : (strong && text.startsWith(strong.textContent.trim()) ? strong.textContent.trim() : '');
        const group = lead && lead === lead.toUpperCase() ? groups.find((g) => g.re.test(lead)) : null;
        if (group) current = group;
        if (!current) return;
        if (!moved.has(current)) moved.set(current, []);
        moved.get(current).push(el);
      });
      let after = item;
      groups.forEach((g) => {
        const els = moved.get(g);
        if (!els || !els.some((el) => !el.hidden && el.textContent.trim())) return;
        const panel = item.cloneNode(false);
        panel.removeAttribute('open');
        panel.innerHTML = item.querySelector('summary').outerHTML;
        panel.querySelector('summary .pf-h5').textContent = g.title;
        const body = desc.cloneNode(false);
        body.removeAttribute('data-pf-desc');
        els.forEach((el) => body.appendChild(el));
        panel.appendChild(body);
        after.after(panel);
        after = panel;
      });
    });

    // Plain quantity selector (no tiers): the unit price stays, the button shows the total.
    const stepper = pdp.querySelector('[data-pf-stepper]');
    if (stepper) {
      const input = stepper.querySelector('[data-pf-qty-input]');
      const apply = (q) => {
        const qty = Math.min(99, Math.max(1, Math.round(Number(q) || 1)));
        input.value = qty;
        qtyInput.value = qty;
        set('[data-pf-btn-total]', formatMoney(unit * qty, fmt));
      };
      stepper.querySelectorAll('[data-pf-step]').forEach((btn) => {
        btn.addEventListener('click', () => apply(Number(input.value) + Number(btn.dataset.pfStep)));
      });
      input.addEventListener('change', () => apply(input.value));
    }

    // Sticky bar: its button submits the main form and copies the main button's state ("Aggiunto ✓", disabled).
    const sticky = pdp.querySelector('[data-pf-sticky-add]');
    const mainBtn = pdp.querySelector('.pf-pdp__add');
    if (sticky && mainBtn) {
      const label = sticky.innerHTML;
      sticky.addEventListener('click', () => mainBtn.click());
      new MutationObserver(() => {
        sticky.disabled = mainBtn.disabled;
        const added = mainBtn.textContent.includes('✓');
        if (added) sticky.textContent = mainBtn.textContent.trim();
        else if (sticky.innerHTML !== label) sticky.innerHTML = label;
      }).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });

      // The WhatsApp app button lives in a shadow root the theme CSS can't reach: lift it above the bar.
      const liftWhatsApp = () => {
        const root = document.querySelector('gty-whatsapp-chat-button')?.shadowRoot;
        if (!root) return false;
        if (!root.querySelector('[data-pf-lift]')) {
          const style = document.createElement('style');
          style.dataset.pfLift = '';
          style.textContent = '.gty-wacb-wrapper { bottom: 92px !important; }';
          root.appendChild(style);
        }
        return true;
      };
      if (!liftWhatsApp()) {
        const watch = new MutationObserver(() => { if (liftWhatsApp()) watch.disconnect(); });
        watch.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => watch.disconnect(), 15000);
      }
    }

    const slides = [...pdp.querySelectorAll('.pf-gallery__slide')];
    const thumbs = [...pdp.querySelectorAll('[data-pf-thumb]')];
    let current = 0;
    const show = (i) => {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === current));
      thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.pfThumb) === current));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.pfThumb))));
    pdp.querySelector('[data-pf-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    pdp.querySelector('[data-pf-gallery-next]')?.addEventListener('click', () => show(current + 1));

    pdp.querySelectorAll('[data-pf-upsell]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const label = btn.innerHTML;
        btn.disabled = true;
        try {
          const body = new FormData();
          body.append('id', btn.dataset.pfUpsell);
          body.append('quantity', '1');
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
          if (!res.ok) throw new Error('add failed');
          const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
          setCount(cart.item_count);
          btn.textContent = 'Aggiunto ✓';
        } catch (err) {
          btn.textContent = 'Riprova';
        }
        setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 1800);
      });
    });
  });
})();
